import { Container, Row, Col } from "react-bootstrap";
import MobileFooter from "../components/mobileFooter";
import MobileNavigationBar from "../components/mobileNavbar";
import tree from "../assets/tree.png"; // replace with correct path

const NonMuslims = () => {
    return (
        <div className="position-relative">
            <MobileNavigationBar />

            {/* Top Header Section */}
            <Row className="px-2 py-2 pt-3" style={{ backgroundColor: '#DEE4D3' }}>
                <Col>
                    <h3 className="fw-bold mb-2 text-center">Doing Good for All:</h3>
                    <h4 className="fw-semibold mb-3 text-center">Supporting Muslims and Non-Muslims Alike</h4>
                    <div className="text-center">
                        <p className="mb-0 fw-medium" style={{ fontSize: "1.2rem" }}>
                            وَتَعَاوَنُوا عَلَى الْبِرِّ وَالتَّقْوَىٰ ۖ وَلَا تَعَاوَنُوا عَلَى الْإِثْمِ وَالْعُدْوَانِ
                        </p>
                        <p className="mb-0 fw-medium">
                            “And cooperate in righteousness and piety, but do not cooperate in sin and aggression.”
                        </p>
                        <p className="fw-medium">— Surah Al-Ma’idah (5:2)</p>
                    </div>
                </Col>
            </Row>

            <Container className="mt-4 mb-5">
                {/* One Act of Kindness */}
                <Row className="text-center mb-2">
                    <h4>Faith inspires us to serve all. Together, we build a kinder, stronger Austin community.</h4>
                    <h4>One Act of Kindness For All</h4>
                </Row>

                <Row className="justify-content-center">
                    <Col className="text-center">
                        <p style={{ textAlign: "justify" }}>
                            At the Greater Austin Muslim Relief Committee (GAMRC), we believe that compassion knows no boundaries.
                            While our mission is rooted in Islamic values and funded through Sadaqah (voluntary charity
                            given in the name of Allah), we extend our help to anyone in need — regardless of faith, background, or ethnicity.
                            We live here. We give here. We help here.
                        </p>
                    </Col>
                </Row>

                <hr className="my-4" />

                {/* Why We Help + Quote */}
                <Row className="my-0">
                    <Col xs={12}>
                        <h3 className="mb-3">Why We Help Everyone</h3>
                        <p style={{ textAlign: "justify" }}>
                            Helping non-Muslims isn't just kindness — it's part of our duty as Muslims. Islam calls us to be a source
                            of comfort, support, and good for all people.
                        </p>
                        <p style={{ textAlign: "justify" }}>
                            That’s why our Sadaqah-funded programs reach across faith lines — offering relief to survivors of domestic abuse,
                            meals to the hungry, and support to seniors in need. Because building a better Austin means uplifting everyone.
                        </p>
                    </Col>
                </Row>

                <Row className="my-0 justify-content-center">
                    <Col xs={12} className="text-center">
                        <img
                            src={tree}
                            alt="Tree"
                            style={{
                                width: "60%",
                                maxWidth: "220px",
                                borderRadius: "10px",
                                marginBottom: "1rem"
                            }}
                        />
                        <h4 className="mb-2">“Is there any reward for good other than good?”</h4>
                        <p style={{ fontStyle: "italic" }}>— Surah Ar-Rahman (55:60)</p>
                    </Col>
                </Row>

                {/* Inclusive Work Examples */}
                <Row className="mb-4">
                    <Col>
                        <h4>Examples of Inclusive Work We Support:</h4>
                        <ul>
                            <li>Meals on Wheels: Providing meals for the elderly in need</li>
                            <li>Drive A Senior (Chariot): Offering transportation to seniors</li>
                            <li>Natural Disaster Relief: Helping all those affected by floods, storms, or emergencies</li>
                            <li>Feed the Homeless Initiatives: Supporting warm meals for vulnerable populations in Austin</li>
                        </ul>
                        <p className="mt-2">
                            Special thanks to the generous contributions of ICBC, ICGA, and Nueces Mosque
                        </p>
                    </Col>
                </Row>

                {/* Sadaqah Section */}
                <Row className="mb-4">
                    <Col>
                        <h4>Guided By Sadaqah</h4>
                        <p style={{ textAlign: "justify" }}>
                            All these initiatives are made possible through Sadaqah — voluntary charity that embodies the Islamic
                            value of giving freely for the sake of Allah. It allows us to uplift the entire community, fulfill
                            urgent needs, and bring comfort to those in need.
                        </p>
                    </Col>
                </Row>

                <hr className="my-4" />

                {/* Need Help Section */}
                <Row className="align-items-center my-4">
                    <Col>
                        <div
                            className="text-center d-flex align-items-center justify-content-center"
                            style={{
                                backgroundColor: "#D4C5E4",
                                padding: "2rem",
                                borderRadius: "10px",
                            }}
                        >
                            <h4 className="mb-0">
                                Need Help? We’re Here for You, No Matter Your Faith
                            </h4>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <p style={{ textAlign: "justify" }}>
                            At the Greater Austin Muslim Relief Committee (GAMRC), we believe in serving everyone in our community with compassion,
                            dignity, and respect. If you or someone you know is in need of assistance, regardless of religious background—we are here to help.
                        </p>
                        <p style={{ textAlign: "justify" }}>
                            Whether you're facing financial hardship, food insecurity, housing instability, or need other forms of support, you are welcome to reach out.
                        </p>
                        <p style={{ textAlign: "justify" }}>
                            👉 <a href="/Contact">Click here to contact us</a> <br />
                            Together, let’s build a more caring and united Austin.
                        </p>
                    </Col>
                </Row>
            </Container>

            <MobileFooter />
        </div>
    );
};

export default NonMuslims;
